import React, { useEffect, useState } from 'react';
import { useMount } from 'ahooks'

import copyText from '../utils/copyText';
import downloadUrlFile from '../utils/downloadFile';
import { CURRENT_HOST, CURRENT_MAIN_HOST } from '../constant';

export default function (props) {
  const [imageList, setImageList] = useState([]);
  const { videos, xImagelist, desc } = props;

  const copyTextHandle = (text) => {
    copyText(text);
    /* global layer */
    layer.msg('已复制到剪切板', {
      time: 2000,
    });
  };
  const downloadHandle = (url) => {
    if (Array.isArray(url)) {
      url.map((item) => downloadUrlFile(dealWithVideo(item)));
    } else {
      downloadUrlFile(dealWithVideo(url));
    }
  };
  const dealWithVideo = (videoUrl) => {
    if (videoUrl.startsWith(`https://zh.${CURRENT_MAIN_HOST}/normal`)) {
      return "https://" + videoUrl.replace(`https://zh.${CURRENT_MAIN_HOST}/normal/`, '');
    } else if (videoUrl.startsWith(`https://video.${CURRENT_MAIN_HOST}/douyin`)) {
      return "https://" + videoUrl.replace(`https://video.${CURRENT_MAIN_HOST}/douyin/`, '');
    } else if(videoUrl.startsWith('https://service-jj4onrsd-1258242193.sh.apigw.tencentcs.com/release/proxy')){
      const url = new URL(videoUrl)
      const realPath = atob(url.searchParams.get('target'))
      return dealWithVideo(realPath)
    } else if(videoUrl.startsWith('https://service-jj4onrsd-1258242193.sh.apigw.tencentcs.com/release')){
      const url = videoUrl.replace('https://service-jj4onrsd-1258242193.sh.apigw.tencentcs.com/release', 'https:/')
      return dealWithVideo(url)
    }
    return videoUrl;
  };
  const onImageClick = (index) => {
    imageList[index].select = !imageList[index].select;
    setImageList([...imageList]);
  }
  useMount(() => {
    setImageList(
      JSON.parse(JSON.stringify(xImagelist))
    )
  });
  return (<div
    style={{
      padding: "20px 10px",
      textAlign: "center",
      display: "flex",
      flexFlow: "column",
    }}
  >
    {videos.map((item, index) => {
      return (
        <div className="media" key={index}>
          <div style={{ width: "40%", margin: "auto" }}>
            <video
              width="100%"
              src={dealWithVideo(item)}
              controls="controls"
              autoPlay
            ></video>
          </div>
          <div>
            <button
              className="layui-btn download-video"
              onClick={() =>
                downloadHandle(dealWithVideo(item))
              }
            >
              下载视频
            </button>
          </div>
        </div>
      );
    })}
    {Boolean(imageList.length) && (
      <div className="media">
        <div className="imagelist">
          {imageList.map((item, index) => (
            <div
              key={index}
              className="imagelist-wrap"
              onClick={() => onImageClick(index)}
            >
              <img className="imagelist-wrap-img" src={item.url} alt="" />
              {
                item.select && <img
                className="select-icon"
                src="https://cdn.soutuya.com/duck.svg"
              />
              }
              
            </div>
          ))}
        </div>
        <div>
          <button
            className="layui-btn"
            onClick={() =>
              downloadHandle(
                imageList
                  .filter((item) => item.select)
                  .map((item) => item.url)
              )
            }
          >
            <span>下载所有图片</span>
            <span className="howpic">
              ({imageList.filter((item) => item.select).length})张
            </span>
          </button>
        </div>
      </div>
    )}
    {desc && (
      <div className="media">
        <div className="desc">{desc}</div>
        <div>
          <button
            className="layui-btn download-text"
            onClick={() => copyTextHandle(desc)}
          >
            复制这些文本
          </button>
        </div>
      </div>
    )}
  </div>)
}